import { Lock as LockIcon } from '@material-ui/icons';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import { verificationSession } from '../../../api/taptotip/profile';

class VerifyButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = { submitted: false };
    this.handleClick = this.handleClick.bind(this);
  }

  async componentDidMount() {
    this.setState({ stripe: await this.props.stripePromise });
  }

  async handleClick(event) {
    // Block native event handling.
    event.preventDefault();

    const { stripe } = this.state;

    if (!stripe) {
      // Stripe.js hasn't loaded yet. Make sure to disable
      // the button until Stripe.js has loaded.
      return;
    }

    // Call your backend to create the VerificationSession.
    const session = await verificationSession();

    // Show the verification modal.
    const { error } = await stripe.verifyIdentity(session.client_secret);

    if (error) {
      console.log('[error]', error.message);
    } else {
      this.setState({ submitted: true });
    }
  }

  render() {
    const { stripe, submitted } = this.state;

    if (submitted) {
      return (
        <>
          <h1 className="text-xl font-bold text-slate-800 tracking-tight">
            Thanks for submitting your identity document
          </h1>
          <p className="text-slate-500 mt-2">We are processing your verification.</p>
        </>
      );
    }

    return (
      <button
        type="button"
        role="link"
        disabled={!stripe}
        onClick={this.handleClick}
        className="inline-flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-5 py-2.5 rounded-xl shadow-sm transition-colors cursor-pointer border-0 disabled:opacity-50 disabled:cursor-not-allowed">
        <LockIcon fontSize="small" />
        Verify your identity
      </button>
    );
  }
}

// const stripePromise = loadStripe(
//   'pk_test_51Gr4YqAt5pYWicpGrVErNE41qPrmHkmcJhveIXIa8cYsg0etCR9pw1uToKovZdvHkIcaVA3Ejgqsckqji7QobyHT00VHlvLHvZ'
// );

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_DEFAULT);

const App = () => {
  return <VerifyButton stripePromise={stripePromise} />;
};

export default App;
